<bfx-text-input
  #textInput
  [bfxTooltip]="data.errorMsg ? data.errorMsg : null"
  tooltipPosition="top"
  tooltipStyleClass="bfx-tooltip-negative-bold"
  [(ngModel)]="data.text"
  [inputLabelText]="label"
  [inputStartContainer]="inputStartContainer"
  [size]="'sm'"
  pInputText
  [maxLength]="config.maxLength"
  (focus)="onFocus($event)"
  (blur)="onBlur($event)"
  [(ngModel)]="data.text"
  class="icd__text-field"
  [disabled]="data.disabled || disabled || locked || (auxCheckbox.enabled && !auxCheckbox.value)"
  [externalState]="data.state"
  type="search"
  autocomplete="off"
>
  <ng-template #inputStartContainer let-chkBoxLabel>
    <p-checkbox
      name="showInput"
      value="showInput"
      [bfxInputLabelOnClick]="chkBoxLabel"
      class="icd__base__checkbox bfx-checkbox-enable-control"
      binary="true"
      [disabled]="auxCheckbox.locked || disabled || locked || auxCheckbox.permanentLock"
      [(ngModel)]="auxCheckbox.value"
      (onChange)="onAuxCheckboxChange()"
      [style.display]="auxCheckbox.enabled ? 'flex' : 'none'"
    ></p-checkbox>
  </ng-template>
</bfx-text-input>
